module.exports = __webpack_public_path__ + "img/profile-placeholder.a5369809.png";